import { computed, ref, watch } from 'vue';
import { useRequestApi } from '@/composition/fetch';
export class CompanyForm {
    companyId = '';
    companyName = '';
    companyApiKey = '';
    valid = false;
}
export const useCompanyForm = (api, company = ref(new CompanyForm())) => {
    const form = ref(new CompanyForm());
    watch(company, (company) => {
        form.value = { ...company, valid: false };
    }, { immediate: true });
    const { request, state } = useRequestApi(api, 0);
    const rules = {
        companyIdRules: [
            (v) => !!v || 'ID is Required',
            (v) => /^[a-z]+([a-z]|[0-9])*$/.test(v) || 'input only start lower or number',
            (v) => (v && v.length > 4) || 'Length is more then 4',
            (v) => (v && v.length < 50) || 'Length is less then 50'
        ],
        companyNameRules: [(v) => !!v || 'Name is Required']
    };
    return {
        form,
        rules,
        loading: computed(() => state.loading),
        save: () => request(form.value)
    };
};
